import * as React from 'react'
import { LabelInner, StyledNavigationLink } from './styled'
import { NavigationLinkProps } from './types'

export const NavigationLink = ({
  activeClassName,
  as,
  children,
  inverted,
  isActive,
  isFullwidth,
  useTheme,
  ...rest
}: NavigationLinkProps) => {
  const buttonClass: string[] = []
  if (isActive) {
    buttonClass.push('active')
  }
  if (!useTheme) {
    buttonClass.push('theme-reset')
  }

  return (
    <StyledNavigationLink
      className={buttonClass.join(' ')}
      as={as}
      activeClassName="active"
      target={rest.target || undefined}
      $inverted={inverted}
      $fullwidth={isFullwidth}
      {...rest}
    >
      <LabelInner className="label" $fullwidth={isFullwidth}>
        {children}
      </LabelInner>
    </StyledNavigationLink>
  )
}
